import React from 'react';
import {Grid, Typography} from "@mui/material";
import {log} from "../../../utils/log";
import GridLinhaDisciplina from "./GridLinhaDisciplina";



type Props = {
  text?: string,
  eilId: number,
  eId: number,
  aluno: any
 
};

type State = {
  checked: boolean,
};

const sxStyles = {
  marginGrid: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '30px',
    marginRight: '20px',
    padding: '0px'
    
  },
  mainGrid: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '30px',
    padding: '0px'
    
  },
  
  cabecalhoDados: {
    display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', width: '50%'
  },

  fieldGrid: {
  
  },
  summary:{
    backgroundColor: '#c5c5c5'
  },
  disciplinaColuna: {
     display: 'flex',
     flexDirection: 'row',
     flexWrap: 'wrap',
      margin: '0px',
      padding: '0px'
  }
  
}


export class FichaGradeGeralNotasAlunoImpressao extends React.PureComponent< Props, State> {
  
  constructor( props:  Props) {
    super(props);
    
    this.state = { checked: false };
  }

  render() {
    const aluno =  this.props.aluno;
  
    log(3,"printable this.props.aluno object", this.props.eilId, this.props.eId, aluno);
  
    const {eId} = this.props;
    const ixdetail : any = aluno.enrollmentInLevel.findIndex((eil: any) => eil.id === this.props.eilId) ;
    
    if (ixdetail < 0) {
      return (<div><Typography variant={'caption'}>not found. {this.props.eId}</Typography>
      </div>)
    }
    
    if (!aluno || !this.props.eId || !aluno.enrollmentInLevel
          || aluno.enrollmentInLevel.length === 0 ||  !aluno.enrollmentInLevel[ixdetail].enrollment ) {
      return (<div><Typography variant={'caption'}>{this.props.eId}</Typography>
      </div>)
    }
    
    
    
    
   // log(3,"enrollemtnmatricula",ixdetail);
    const data = aluno.enrollmentInLevel[ixdetail].enrollment.find((e: any) => e.id === this.props.eId) ;
    const dataEil = { ...aluno.enrollmentInLevel[ixdetail] };
    
  
    log(3,"printable data", this.props.eId,  dataEil);
  
  

      
      //Monta estrutura de disciplinas
      let numModulos = 0;
      
      // pesquisa numero de modulos maximos
      dataEil.level.discipline.map((d: any) => {
        if (d.disciplineModule) {
          d.disciplineModule.map((m: any) => {
              if (m.Module > numModulos) {
                numModulos = m.Module;
              }
          });
        }
      });
      
      // monta grade de disciplinas e modulos
      let gridDisciplinas : any[] = [];
      let modVazios :any[] = [];
      for (let i = 0; i < numModulos; i++) {
        modVazios.push({ etapa: i+1, empty: true });
      }
      
      dataEil.level.discipline.map((d: any) => {
        
        let linhaDisc = {};
        let ixDisc = gridDisciplinas.findIndex((g: any) => g.discId === d.id);
        if (ixDisc < 0) {
          linhaDisc = { discId: d.id,  disciplina: d.Description, modulos: [...modVazios ]  };
          gridDisciplinas.push({ ...linhaDisc });
        }
        
        ixDisc = gridDisciplinas.findIndex((g: any) => g.discId === d.id);
        
        d.disciplineModule.map((m: any) => {
            const ixm =  gridDisciplinas[ixDisc].modulos.findIndex((mm: any) => mm.etapa === m.Module );
            gridDisciplinas[ixDisc].modulos[ixm] =
                { etapa: m.Module, dmod: {...m} }
            ;
        });
      });
      
      //console.log("gridDisciplinas", JSON.stringify(gridDisciplinas));
      
      // preenche grade disciplinas com as matriculadas aprovadas
    
    let dees : any[] = [];
      dataEil.enrollment.map((e: any) => {
        e.disciplineEntree.map((edee: any) => {
          const ix = gridDisciplinas.findIndex((g: any) => g.discId === edee.disciplineOffer.discipline.id);
          if (ix >= 0) {
            
            const ixm = gridDisciplinas[ix].modulos.findIndex((m: any) => m.etapa === edee.disciplineOffer.disciplineModule.Module);
            if (ixm >= 0) {
             dees = [];
              if (gridDisciplinas[ix].modulos[ixm].dees) {
                dees = [ ...gridDisciplinas[ix].modulos[ixm].dees ];
              }
              dees.push(edee);
              gridDisciplinas[ix].modulos[ixm] = { ...gridDisciplinas[ix].modulos[ixm], dees: [...dees ] };
            }
          }
        });
      });
      
      console.log("gridDisciplinas preenchido", gridDisciplinas);
      
      
      
      
      
      
 

    log(3,"FichaMatruloa returning...")
  
    return (
        <div className='print'>
          <Grid container sx={{...sxStyles.marginGrid}}>
          <Grid id='cabecalho' container sx={{...sxStyles.mainGrid}}>
            <Grid container item style={{ }}>
              <Grid container item style={{ width: '25%'}}>
                <img className="picture-src"
                     src="https://api-fermi.cientificoeducacao.com.br/api/PersonPics/fermi-images.cientificoeducacao.com.br/download/logoCientifico.png"
                     width={200} height={63}></img>
              </Grid>
              <Grid container item  sx={{ ...sxStyles.cabecalhoDados}}>
                <Typography variant={'caption'} style={{ lineHeight: 0}}>CIENTIFICO</Typography><br/>
                <Typography variant={'caption'} style={{ lineHeight: 0}}>EDUCAÇÃO DE JOVENS E ADULTOS</Typography><br/>
                <Typography variant={'caption'} style={{ lineHeight: 0}}>EAD
                  - {aluno.enrollmentInLevel[ixdetail] ? aluno.enrollmentInLevel[ixdetail].level.OfficialText : ""}</Typography><br/>
                <Typography variant={'caption'} style={{ lineHeight: 0}}>GRADE DE FREQUENCIA E RESULTADOS</Typography><br/>

              </Grid>
           
            </Grid>
          </Grid>
        
          <Grid id='identificacao' container>
            <Grid container item >
              <Grid item style={{ width: '70%'}}>
                <Typography variant={'caption'}>ALUNO ({data ? data.id : ""}):</Typography>
                <Typography id='Aluno' className="fieldname">{aluno ? aluno.Name : ""}</Typography>
              </Grid>
              <Grid item style={{ width: '15%'}}>
                <Typography variant={'caption'}>CPF:</Typography>
                <Typography className="fieldname" >{aluno ? aluno.IndividualIdentity : ""}</Typography>
              </Grid>
              <Grid item style={{ width: '15%'}}>
                <Typography variant={'caption'}>CARNÊ:</Typography>
                <Typography id='Carne' className="fieldname">{data.enrollment ? data.enrollment.PaymentCard : ""}</Typography>
              </Grid>
            </Grid>
          </Grid>
        
            
            <Grid item container style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap',  width: '100%', margin: '0px', padding: '0px'}}>
              <Grid item container sx={{...sxStyles.disciplinaColuna}} >
                {
                  gridDisciplinas.map((d: any, key:number) => {
                    return ( <GridLinhaDisciplina key={d.discId} disciplina={d} />  );
                  })
                }
              </Grid>
            </Grid>
       
          </Grid>
        </div>
    );
  
  }

}



export default (FichaGradeGeralNotasAlunoImpressao)

export const FunctionalFichaGradeGeralNotasAlunoComponentToPrint = React.forwardRef<FichaGradeGeralNotasAlunoImpressao | null,  Props>((props, ref) => {
  // eslint-disable-line max-len
  log(3,"Execute FunctionalComponentToPrint");
  return <FichaGradeGeralNotasAlunoImpressao ref={ref} {...props} />;
});
